import { TextEditorComponent } from './text-editor.component'
import { CommonModule } from '@angular/common'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { NgModule } from '@angular/core'
import { NgxTiptapModule } from 'ngx-tiptap'
import { FormsModule } from '@angular/forms'
import { SharedModule } from '@shared/shared.module'

@NgModule({
  declarations: [TextEditorComponent],
  imports: [
    CommonModule,
    FormsModule,
    BrowserAnimationsModule,
    NgxTiptapModule,
    SharedModule,
  ],
  exports: [TextEditorComponent],
})
export class TextEditorModule {}
